var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 48,
    viewBox: "0 0 83 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82.963,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.92578,
    y: 6.51855,
    width: 71.1111,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8516,
    y: 13.0371,
    width: 59.2593,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7773,
    y: 19.5557,
    width: 47.4074,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7041,
    y: 26.074,
    width: 35.5556,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6299,
    y: 32.5925,
    width: 23.7037,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5557,
    y: 38.5186,
    width: 11.8519,
    height: 2.96296,
    fill: "#0A8FFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5186,
    y: 45.0371,
    width: 5.92593,
    height: 2.96296,
    fill: "#0A8FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight);
export default __webpack_public_path__ + "static/media/Straight.96099bdaf00aee3cf9e5fa46b7e9de4a.svg";
export { ForwardRef as ReactComponent };